import { get } from 'lodash/fp';
import { API_URL } from '../../../app-config/constants';
import type SiRoleDefinitionDto from '../../../types/SiRoleDefinitionDto';
import type { UserWithSiRolesDto } from '../../../types/UserWithSiRolesDto';
import { get as getRequest, put } from '../request';

const RESOURCE = `${API_URL}/si-roles`;

getUsersWithRoles.operation = 'READ';
export function getUsersWithRoles() {
    return getRequest<UserWithSiRolesDto[]>(`${RESOURCE}`);
}

// getAllRoles.operation = 'READ';
getAllRoles.idFrom = get('role');
export function getAllRoles() {
    return getRequest<SiRoleDefinitionDto[]>(`${RESOURCE}/roles`);
}

updateRoles.operation = 'COMMAND';
export function updateRoles(userId: string, rolesAndDates: { [role: string]: string }) {
    return put<UserWithSiRolesDto>(`${RESOURCE}/${userId}`, {
        postData: rolesAndDates,
    });
}
